export default __webpack_public_path__ + "locales/tr/JavascriptSdk.json?hash=764cb51bb0051f75b7dc55f0ef707649";